/**
 * Returns an object based on a URLencoded search string 
 * @example
 * // { "s": "31,26", "t": "[39,31],[32]" }
 * // searchToObject('?s=31%2C26&t=%5B39%2C31%5D%2C%5B32%5D');
 * @param {string} string a URLencoded set or query parameters as a string
 * @returns {object} an object representation of a URLencoded search string
 */
export function searchToObject(string) {
    const urlParams = new URLSearchParams(string);
    return paramsToObject(urlParams.entries());
}

/**
 * Returns an object based on URLSearchParams 
 * @param {URLSearchParams} entries
 * @returns {object} 
 */
export function paramsToObject(entries) {
    const result = {};
    for (const [key, value] of entries) {
        // each 'entry' is a [key, value] tupple
        result[key] = value;
    }
    return result;
}

export function updateURL(journeyObject) {
    const newJourney = new URLSearchParams(journeyObject).toString();

    const newURL =
        window.location.origin + window.location.pathname + `?${newJourney}`;

    // window.history.replaceState({ path: newURL }, "journey", newURL);
}

export function shortlistToString(shortlist) {
    return shortlist.map((listing) => listing.id).join(",");
}

export function journeyToString(journey) {
    return journey
        .map((day) => {
            return `[${day.listings.map((listing) => listing.id).join(",")}]`;
        })
        .join(",");
}

export function journeyToURL(journey) {

    const journeyObject = searchToObject(window.location.search);

    journeyObject.t = journeyToString(journey);

    // updateURL(journeyObject)
}

export function shortlistToURL(shortlist) {

    const journey = searchToObject(window.location.search);

    journey.s = shortlistToString(shortlist);

    // updateURL(journey)
}
